import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { selectSearchText } from "../../../store/documentList/selectors/selectSearchText";
import { fetchDocuments } from "../../../store/documentList/actions/fetchDocuments";
import { setSearchText } from "../../../store/documentList";

export const SearchTextInput: React.FC = () => {
  const dispatch = useDispatch();
  const value = useSelector(selectSearchText);
  return (
    <IonSearchbar
      value={value}
      onIonChange={({ detail: { value = "" } }) => {
        dispatch(setSearchText(value));
        dispatch(fetchDocuments());
      }}
      debounce={700}
      placeholder={"Buscar acuerdo"}
    />
  );
};
